import { useState } from "react";
import gpdr from "./gpdr.txt";
import general from "./general.txt";
import process from "./process.txt";
import versionnotes from "./versionnotes.txt";


const TextToVar = ({infotext}) => {
    const [text, setText] = useState("");

    switch (infotext) {
      case "gpdr":
    fetch(gpdr)
      .then((response) => response.text())
      .then((textContent) => {
        setText(textContent);
      });
      break;

      case "general":
      fetch(general)
      .then((response) => response.text())
      .then((textContent) => {
        setText(textContent);
      });
      break;

      case "process":
      fetch(process)
      .then((response) => response.text())
      .then((textContent) => {
        setText(textContent);
      });
      break;

      case "versionnotes":
      fetch(versionnotes)
      .then((response) => response.text())
      .then((textContent) => {
        setText(textContent);
      });
      break;

      default:
        break;  
    }

   
    return text 
  }
export default TextToVar